import React from 'react'

export default function List({className}) {
    return (
        <svg 
        className={`w-6 h-6 text-gray-600 ${className} `} 
        aria-hidden="true" xmlns="http://www.w3.org/2000/svg" 
        fill="none" 
        viewBox="0 0 24 24">
            <path stroke="currentColor" strokeLinecap="round" strokeWidth="1.6" d="M9 8h10M9 12h10M9 16h10M5 8h0m0 4h0m0 4h0" />
        </svg>
    )
}
